import { useState } from "react";

export const useCurrencyAndLanguage = ({ i18n, setCurrency }) => {
  const [language, setLanguage] = useState(i18n.language);
  const handleCurrencyChange = (value) => {
    setCurrency(value);
  };

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
  };

  return {
    language,
    handleCurrencyChange,
    handleLanguageChange,
  };
};
